// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles-" + "86467b1cb0a0e1163185" + ".css";
};